// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.profile-statistics-payment-resume-modal.modal2 {
    background-color: var(--body-background-color);
}

.profile-statistics-payment-resume-modal__payment-info {
    padding: 0 90px 48px 90px;
}

.profile-statistics-payment-resume-modal .modal__container {
    margin: 0;
    padding: 0;
    width: 820px;
    max-width: 820px;
}

.profile-statistics-payment-resume-modal .modal2__header {
    border: none;
}

.profile-statistics-payment-resume-modal .modal2__header__close {
    display: none;
}

.profile-statistics-payment-resume-modal__payment-info__actions {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    padding: 16px;
    border-top: 1px solid var(--new-input-background-color);
}

.profile-statistics-payment-resume-modal__payment-info__title.baloa-subtitle-2 {
    color: var(--primary-very-dark-color);
    margin-bottom: 29px;
}

.profile-statistics-payment-resume-modal__payment-info__ref {
    margin-bottom: 36px;
}

.profile-statistics-payment-resume-modal__payment-info__ref .baloa-table {
    color: var(--basic-gray-color);
    margin-bottom: 8px;
}

.profile-statistics-payment-resume-modal__payment-info__ref .baloa-hyperlink-2 {
    color: var(--primary-very-dark-color);
    font-weight: var(--font-medium);
}

.profile-statistics-payment-resume-modal__payment-info__tournament-container .baloa-table {
    color: var(--basic-gray-color);
    margin-bottom: 12px;
}

.profile-statistics-payment-resume-modal__payment-info__tournament-info {
    display: flex;
    align-items: center;
    justify-content: flex-start;
}

.profile-statistics-payment-resume-modal__payment-info__tournament-info__img img {
    width: 39px;
    height: 39px;
    border-radius: 50%;
}

.profile-statistics-payment-resume-modal__payment-info__tournament-info__img .icon-ball {
    color: var( --white-color );
    font-size: 39px;
    border-radius: 50%;
    padding: 4px;
 }

 .profile-statistics-payment-resume-modal__payment-info__tournament-info__tournament {
    margin-left: 8px;
 }

 .profile-statistics-payment-resume-modal__payment-amount {
    margin-top: 36px;
 }

 .profile-statistics-payment-resume-modal__payment-amount .baloa-hyperlink-2 {
    font-weight: var(--font-medium);
    color: var(--basic-gray-color);
    margin-bottom: 12px;
 }

 .profile-statistics-payment-resume-modal__payment-amount .baloa-table {
    font-weight: var(--font-medium);
    color: var(--primary-very-dark-color);
 }

 .profile-statistics-payment-resume-modal__payment-info__tournament-info__tournament .baloa-names {
    color: var(-primary-very-dark-color);
    margin-bottom: 4px;
 }

 .profile-statistics-payment-resume-modal__payment-info__tournament-info__tournament-labels {
    display: flex;
    align-items: center;
    gap: 4px;
 }

 .profile-statistics-payment-resume-modal__payment-info__tournament-info__tournament-labels .baloa-mini {
    color: var(--primary-dark-color);
    padding: 3px 6px;
    background: var(--new-grey-light-background-color);
    border: 1px solid var(--new-grey-border-color);
    border-radius: 25px;
 }

 .profile-statistics-payment-resume-modal__payment-info__actions .secondary-button {
    border: none;
    color: var(--primary-dark-color);
 }

.profile-statistics-payment-resume-modal__payment-info__actions .secondary-button:focus,
.profile-statistics-payment-resume-modal__payment-info__actions .secondary-button:hover,
.profile-statistics-payment-resume-modal__payment-info__actions .secondary-button:active {
    background-color: unset;
    color: var(--primary-dark-color);
}

@media screen and ( max-width: 440px ) { /* Cambio de 430px a 440px */
    .profile-statistics-payment-resume-modal .modal2__container {
        width: 100%;
        margin: 0;
        border-radius: 0;
        max-height: 100%;
        height: 100%;;
    }
    
    .profile-statistics-payment-resume-modal .modal2__content {
        height: 100%;
    }

    .profile-statistics-payment-resume-modal__payment-info__actions {
        justify-content: center;
        gap: 24px;
    }

    .profile-statistics-payment-resume-modal__payment-info {
        padding: 20px 12px;
    }

    .profile-statistics-payment-resume-modal__payment-amount {
        margin-top: 20px;
    }

    .profile-statistics-payment-resume-modal__payment-info__ref {
        margin-bottom: 20px;
    }

    .profile-statistics-payment-resume-modal .modal2__header__close {
        display: block;
    }
}



`, "",{"version":3,"sources":["webpack://./src/app/profiles/components/profile-statistics-payment-resume-modal/ProfileStatisticsPaymentResumeModalComponent.styles.css"],"names":[],"mappings":"AAAA;IACI,8CAA8C;AAClD;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,SAAS;IACT,UAAU;IACV,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,yBAAyB;IACzB,aAAa;IACb,uDAAuD;AAC3D;;AAEA;IACI,qCAAqC;IACrC,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,8BAA8B;IAC9B,kBAAkB;AACtB;;AAEA;IACI,qCAAqC;IACrC,+BAA+B;AACnC;;AAEA;IACI,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,2BAA2B;AAC/B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,2BAA2B;IAC3B,eAAe;IACf,kBAAkB;IAClB,YAAY;CACf;;CAEA;IACG,gBAAgB;CACnB;;CAEA;IACG,gBAAgB;CACnB;;CAEA;IACG,+BAA+B;IAC/B,8BAA8B;IAC9B,mBAAmB;CACtB;;CAEA;IACG,+BAA+B;IAC/B,qCAAqC;CACxC;;CAEA;IACG,oCAAoC;IACpC,kBAAkB;CACrB;;CAEA;IACG,aAAa;IACb,mBAAmB;IACnB,QAAQ;CACX;;CAEA;IACG,gCAAgC;IAChC,gBAAgB;IAChB,kDAAkD;IAClD,8CAA8C;IAC9C,mBAAmB;CACtB;;CAEA;IACG,YAAY;IACZ,gCAAgC;CACnC;;AAED;;;IAGI,uBAAuB;IACvB,gCAAgC;AACpC;;AAEA,yCAAyC,4BAA4B;IACjE;QACI,WAAW;QACX,SAAS;QACT,gBAAgB;QAChB,gBAAgB;QAChB,YAAY;IAChB;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,uBAAuB;QACvB,SAAS;IACb;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,cAAc;IAClB;AACJ","sourcesContent":[".profile-statistics-payment-resume-modal.modal2 {\n    background-color: var(--body-background-color);\n}\n\n.profile-statistics-payment-resume-modal__payment-info {\n    padding: 0 90px 48px 90px;\n}\n\n.profile-statistics-payment-resume-modal .modal__container {\n    margin: 0;\n    padding: 0;\n    width: 820px;\n    max-width: 820px;\n}\n\n.profile-statistics-payment-resume-modal .modal2__header {\n    border: none;\n}\n\n.profile-statistics-payment-resume-modal .modal2__header__close {\n    display: none;\n}\n\n.profile-statistics-payment-resume-modal__payment-info__actions {\n    display: flex;\n    align-items: center;\n    justify-content: flex-end;\n    padding: 16px;\n    border-top: 1px solid var(--new-input-background-color);\n}\n\n.profile-statistics-payment-resume-modal__payment-info__title.baloa-subtitle-2 {\n    color: var(--primary-very-dark-color);\n    margin-bottom: 29px;\n}\n\n.profile-statistics-payment-resume-modal__payment-info__ref {\n    margin-bottom: 36px;\n}\n\n.profile-statistics-payment-resume-modal__payment-info__ref .baloa-table {\n    color: var(--basic-gray-color);\n    margin-bottom: 8px;\n}\n\n.profile-statistics-payment-resume-modal__payment-info__ref .baloa-hyperlink-2 {\n    color: var(--primary-very-dark-color);\n    font-weight: var(--font-medium);\n}\n\n.profile-statistics-payment-resume-modal__payment-info__tournament-container .baloa-table {\n    color: var(--basic-gray-color);\n    margin-bottom: 12px;\n}\n\n.profile-statistics-payment-resume-modal__payment-info__tournament-info {\n    display: flex;\n    align-items: center;\n    justify-content: flex-start;\n}\n\n.profile-statistics-payment-resume-modal__payment-info__tournament-info__img img {\n    width: 39px;\n    height: 39px;\n    border-radius: 50%;\n}\n\n.profile-statistics-payment-resume-modal__payment-info__tournament-info__img .icon-ball {\n    color: var( --white-color );\n    font-size: 39px;\n    border-radius: 50%;\n    padding: 4px;\n }\n\n .profile-statistics-payment-resume-modal__payment-info__tournament-info__tournament {\n    margin-left: 8px;\n }\n\n .profile-statistics-payment-resume-modal__payment-amount {\n    margin-top: 36px;\n }\n\n .profile-statistics-payment-resume-modal__payment-amount .baloa-hyperlink-2 {\n    font-weight: var(--font-medium);\n    color: var(--basic-gray-color);\n    margin-bottom: 12px;\n }\n\n .profile-statistics-payment-resume-modal__payment-amount .baloa-table {\n    font-weight: var(--font-medium);\n    color: var(--primary-very-dark-color);\n }\n\n .profile-statistics-payment-resume-modal__payment-info__tournament-info__tournament .baloa-names {\n    color: var(-primary-very-dark-color);\n    margin-bottom: 4px;\n }\n\n .profile-statistics-payment-resume-modal__payment-info__tournament-info__tournament-labels {\n    display: flex;\n    align-items: center;\n    gap: 4px;\n }\n\n .profile-statistics-payment-resume-modal__payment-info__tournament-info__tournament-labels .baloa-mini {\n    color: var(--primary-dark-color);\n    padding: 3px 6px;\n    background: var(--new-grey-light-background-color);\n    border: 1px solid var(--new-grey-border-color);\n    border-radius: 25px;\n }\n\n .profile-statistics-payment-resume-modal__payment-info__actions .secondary-button {\n    border: none;\n    color: var(--primary-dark-color);\n }\n\n.profile-statistics-payment-resume-modal__payment-info__actions .secondary-button:focus,\n.profile-statistics-payment-resume-modal__payment-info__actions .secondary-button:hover,\n.profile-statistics-payment-resume-modal__payment-info__actions .secondary-button:active {\n    background-color: unset;\n    color: var(--primary-dark-color);\n}\n\n@media screen and ( max-width: 440px ) { /* Cambio de 430px a 440px */\n    .profile-statistics-payment-resume-modal .modal2__container {\n        width: 100%;\n        margin: 0;\n        border-radius: 0;\n        max-height: 100%;\n        height: 100%;;\n    }\n    \n    .profile-statistics-payment-resume-modal .modal2__content {\n        height: 100%;\n    }\n\n    .profile-statistics-payment-resume-modal__payment-info__actions {\n        justify-content: center;\n        gap: 24px;\n    }\n\n    .profile-statistics-payment-resume-modal__payment-info {\n        padding: 20px 12px;\n    }\n\n    .profile-statistics-payment-resume-modal__payment-amount {\n        margin-top: 20px;\n    }\n\n    .profile-statistics-payment-resume-modal__payment-info__ref {\n        margin-bottom: 20px;\n    }\n\n    .profile-statistics-payment-resume-modal .modal2__header__close {\n        display: block;\n    }\n}\n\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
